import React, { useEffect, useState } from "react";
import axios from "axios";
import UpdateQuestion from "./UpdateQuestion";
import { config } from "../../../config";

const apiUrl = config.apiUrl;

const ViewQuestion = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [formData, setFormData] = useState({
    subject_id: "",
    module_id: "",
    lesson_id: "",
    question_text: "",
    difficulty: "easy",
    mark: 1,
    options: [{ option_text: "" }, { option_text: "" }],
    correct_option_index: 0,
  });

  // Fetch questions from API
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${apiUrl}/questionmanagement`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setQuestions(response.data.data || response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching questions:", err);
        setLoading(false);
        setError("প্রশ্নগুলি লোড করতে সমস্যা হয়েছে");
      }
    };

    fetchQuestions();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("আপনি কি এই প্রশ্নটি মুছতে চান?")) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete(`${apiUrl}/questionmanagementdelete/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setQuestions((prev) => prev.filter((q) => q.id !== id));
      } catch (err) {
        console.error("Error deleting question:", err);
        setError("প্রশ্ন মুছতে সমস্যা হয়েছে");
      }
    }
  };

  // Handle Edit
  const handleEditClick = (question) => {
    if (editingQuestion === question.id) {
      setEditingQuestion(null);
    } else {
      setEditingQuestion(question.id);
      setFormData({
        subject_id: question.subject_id,
        module_id: question.module_id || "",
        lesson_id: question.lesson_id || "",
        question_text: question.question_text,
        difficulty: question.difficulty,
        mark: question.mark,
        options: question.options,
        correct_option_index: question.answer
          ? question.options.findIndex(
              (opt) => opt.id === question.answer.option_id
            )
          : 0,
      });
    }
  };

  const handleUpdateSuccess = () => {
    setEditingQuestion(null);
    // Refresh the questions list
    const fetchQuestions = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${apiUrl}/questionmanagement`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setQuestions(response.data.data || response.data);
      } catch (err) {
        console.error("Error fetching questions:", err);
        setError("প্রশ্নগুলি লোড করতে সমস্যা হয়েছে");
      }
    };
    fetchQuestions();
  };

  if (loading) return <div className="text-center py-8">লোড হচ্ছে...</div>;

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">প্রশ্ন তালিকা</h2>
          {error && <div className="bg-red-50 border border-red-200 text-red-800 p-4 rounded-lg mb-4">{error}</div>}

          {questions.length === 0 ? (
            <p className="text-center text-gray-600 py-8">কোনো প্রশ্ন পাওয়া যায়নি</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">বিষয়</th>
                    <th className="border px-4 py-2 text-left">প্রশ্ন</th>
                    <th className="border px-4 py-2 text-left">অপশনগুলি</th>
                    <th className="border px-4 py-2 text-left">সঠিক উত্তর</th>
                    <th className="border px-4 py-2 text-left">কঠিনতা</th>
                    <th className="border px-4 py-2 text-left">মান</th>
                    <th className="border px-4 py-2 text-left">কর্ম</th>
                  </tr>
                </thead>
                <tbody>
                  {[...questions].reverse().map((q) => (
                    <tr key={q.id} className="hover:bg-gray-50">
                      <td className="border px-4 py-2">{q.subject?.name}</td>
                      <td className="border px-4 py-2">
                        <div dangerouslySetInnerHTML={{ __html: q?.question_text || 'প্রশ্ন পাওয়া যায়নি' }} />
                      </td>
                      <td className="border px-4 py-2">
                        <ul className="list-disc pl-5">
                          {q.options.map((opt) => (
                            <li key={opt.id}>{opt.option_text}</li>
                          ))}
                        </ul>
                      </td>
                      <td className="border px-4 py-2 font-bold text-green-700">
                        {q.answer?.option?.option_text}
                      </td>
                      <td className="border px-4 py-2 capitalize">
                        {q.difficulty === 'easy' ? 'সহজ' : 
                         q.difficulty === 'medium' ? 'মধ্যম' : 'কঠিন'}
                      </td>
                      <td className="border px-4 py-2">{q.mark}</td>
                      <td className="border px-4 py-2">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => handleEditClick(q)}
                            className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600 transition-colors"
                          >
                            {editingQuestion === q.id ? "বাতিল" : "সম্পাদনা"}
                          </button>
                          <button
                            onClick={() => handleDelete(q.id)}
                            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition-colors"
                          >
                            মুছুন
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {editingQuestion && (
            <div className="mt-8">
              <UpdateQuestion
                questionId={editingQuestion}
                formData={formData}
                setFormData={setFormData}
                onSuccess={handleUpdateSuccess}
                onCancel={() => setEditingQuestion(null)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewQuestion;